import {
  isCVV,
  isCreditCardNumber,
  isEmpty,
  isEmail,
  isCPForCNPJ,
  isMobile,
  isCPF,
} from '../helpers/validation';

export const useError = () => {
  const goToFieldWithError = (id) => {
    const element = document.getElementById(id);
    let offset = 150;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
    document.getElementById(id).focus();
  };

  const attendeeError = {
    cp_code: (attendee) => !isEmpty(attendee.cp_code),
    cp_name: (attendee) => !isEmpty(attendee.cp_name),
    // focal_point: (attendee) => !isEmpty(attendee.focal_point),
    name: (attendee) => !isEmpty(attendee.name),
    role: (attendee) => !isEmpty(attendee.role),
    email: (attendee) => isEmail(attendee.email),
    document: (attendee) => isCPF(attendee.document),
    mobile: (attendee) => isMobile(attendee.mobile),
    store_code: (attendee) => !isEmpty(attendee.store_code),
    hair_knowledge: (attendee) => !isEmpty(attendee.hair_knowledge),
    lgpd: (attendee) => attendee.lgpd,
  };

  const cctokenError = {
    number: (cctoken) => isCreditCardNumber(cctoken.number),
    name: (cctoken) => !isEmpty(cctoken.name),
    country: (cctoken) => !isEmpty(cctoken.country),
    expireAt: (cctoken) => !isEmpty(cctoken.expireAt),
    code: (cctoken) => isCVV(cctoken.code),
  };

  const customerError = {
    name: (customer) => !isEmpty(customer.name),
    document: (customer) => isCPForCNPJ(customer.document),
    email: (customer) => isEmail(customer.email),
    mobile: (customer) => isMobile(customer.mobile),
    address: (customer) => !isEmpty(customer.address),
  };
  return {
    attendeeError,
    customerError,
    cctokenError,
    goToFieldWithError,
  };
};
